export type DeepLinkAction = 'created' | 'updated' | 'deleted' | 'closed';

export interface DeepLinkParams {
  action: DeepLinkAction;
  ticket_id?: string;
  ticket_count?: number;
}

/**
 * Check if we're running inside a native WebView (where custom schemes work)
 * vs. a desktop browser (where they break MSW + SPA navigation).
 */
function isWebViewEnvironment(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  // Android WebView or iOS WKWebView indicators
  return ua.includes('wv') || ua.includes('webview') || /\bkarofi\b/i.test(ua);
}

export function triggerDeepLink(params: DeepLinkParams): void {
  const { action, ticket_id, ticket_count } = params;

  const url = new URL('karofi://market-defect-done');
  url.searchParams.set('action', action);

  if (ticket_id) {
    url.searchParams.set('ticket_id', ticket_id);
  }

  if (ticket_count !== undefined) {
    url.searchParams.set('ticket_count', ticket_count.toString());
  }

  const deepLinkUrl = url.toString();

  // Only trigger the native deep link in a WebView environment.
  // On desktop browsers the karofi:// scheme is unregistered and
  // setting window.location.href breaks MSW + SPA navigation.
  if (isWebViewEnvironment()) {
    window.location.href = deepLinkUrl;
  } else {
    console.log('[DeepLink] Skipped (not in WebView):', deepLinkUrl);
  }
}

export function generateDeepLinkUrl(params: DeepLinkParams): string {
  const { action, ticket_id, ticket_count } = params;

  const url = new URL('karofi://market-defect-done');
  url.searchParams.set('action', action);

  if (ticket_id) {
    url.searchParams.set('ticket_id', ticket_id);
  }

  if (ticket_count !== undefined) {
    url.searchParams.set('ticket_count', ticket_count.toString());
  }

  return url.toString();
}
